if (!customElements.get('load-more-button')) {
	class LoadMoreButton extends HTMLElement {
		constructor() {
			super();

			// next page URL, parentElSelector, itemElSelector
			this.totalPages = this.dataset.totalpages;
			this.itemsParentSelector = this.dataset.parentelselector;
			this.itemSelector = this.dataset.itemelselector;

			//state
			this.currentPage = 1;
			this.isNextPage = true;

			// selectors and elements
			this.buttonEl = this.querySelector('.load-more-button--wrapper');
			this.buttonElLoadingSpinner = this.querySelector('.loading-overlay__spinner');
			this.itemsParent = document.querySelector(this.itemsParentSelector);

			this.staticPagination = this.querySelector('.pagination-wrapper');
		}

		connectedCallback() {
			this.buttonEl.addEventListener('click', this.getNextPageItems.bind(this));
		}

		replacePageNumber(newPageNumber) {
			var urlObject = new URL(window.location.href);
			var searchParams = urlObject.searchParams;
			searchParams.set("page", newPageNumber);
			return urlObject.toString();
		}

		getNextPageItems() {
			if (!this.isNextPage) return;

			this.buttonEl.classList.add('hidden');
			this.buttonElLoadingSpinner.classList.remove('hidden');

			const prevPageUrl = this.replacePageNumber(this.currentPage);
			this.staticPagination.querySelector('[rel="prev"]')?.setAttribute('href', prevPageUrl)

			this.currentPage = this.currentPage + 1;

			const nextPageUrl = this.replacePageNumber(this.currentPage + 1);
			this.staticPagination.querySelector('[rel="next"]')?.setAttribute('href', nextPageUrl)

			const newPageUrl = this.replacePageNumber(this.currentPage);


			fetch(newPageUrl, {
				method: 'GET',
				headers: {
					'Content-Type': 'text/html',
				},
			})
				.then((response) => response.text())
				.then((next_page) => {
					const parser = new DOMParser();
					const htmlDocument = parser.parseFromString(next_page, 'text/html');

					const newItems = htmlDocument.querySelectorAll(this.itemSelector);
					
					newItems.forEach((item) => {
						this.itemsParent.appendChild(item);
					});

					this.buttonEl.classList.remove('hidden');
					this.buttonElLoadingSpinner.classList.add('hidden');

					if (this.currentPage == this.totalPages) {
						this.buttonEl.classList.add('disabled');
						this.isNextPage = false;
					}
				})
				.catch((error) => {
					console.error('Error:', error);
				}).finally(() => {
					//refreshing yotpo modules fetched with new content
					if (window.Yotpo && window.Yotpo.API) {
						var api = new window.Yotpo.API(window.yotpo);
						if(api) {
							api.refreshWidgets();
						}
					}

					// refreshing swym wishlist heart button
					document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
				});
				
				
		}
	}

	customElements.define('load-more-button', LoadMoreButton);
}
